import {
  Flame,
  FLAME_DEFAULT_BASE_COLOR,
  FLAME_DEFAULT_HEIGHT,
  FLAME_DEFAULT_MID_COLOR,
  FLAME_DEFAULT_TIP_COLOR,
  FLAME_DEFAULT_WIDTH,
} from '../../object/primitives/Flame';
import { SceneFlameRef } from '../SceneManifest';

/**
 * Multiply a single linear-RGB tint into one of the flame's three default
 * colors. The tint preserves the engine's three-band silhouette (cool base,
 * warm mid, hot tip) while letting the user shift the whole flame toward a
 * different hue with one knob.
 */
export function tintFlameColors(
  base: readonly [number, number, number],
  tint: readonly [number, number, number] | number[],
): [number, number, number] {
  return [base[0] * tint[0], base[1] * tint[1], base[2] * tint[2]];
}

/**
 * Build a runtime `Flame` from a scene-level placement (`SceneFlameRef`).
 * Single source of truth for both the manifest loader and the asset-manager
 * scene-editor preview registry — keeps the simplified-knob mapping (scale →
 * width+height, color → tint multiplied into base/mid/tip) consistent.
 */
export function buildFlameFromRef(ref: SceneFlameRef): Flame {
  const tint = ref.color;
  return new Flame({
    position: [ref.position[0], ref.position[1], ref.position[2]],
    width: FLAME_DEFAULT_WIDTH * ref.scale,
    height: FLAME_DEFAULT_HEIGHT * ref.scale,
    intensity: ref.intensity,
    baseColor: tintFlameColors(FLAME_DEFAULT_BASE_COLOR, tint),
    midColor: tintFlameColors(FLAME_DEFAULT_MID_COLOR, tint),
    tipColor: tintFlameColors(FLAME_DEFAULT_TIP_COLOR, tint),
  });
}
